import { useKeyDown } from './useKeyDown';

export const useEnter = (callback: () => void, isEnabled = true) => {
  useKeyDown('Enter', callback, isEnabled);
};
